exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.switch-btn[data-v-f3720420] {\n    margin: auto;\n    padding: 0 .5rem;\n    height: 24px;\n    font-size: small;\n    line-height: 24px;\n    color: #fff;\n    background: #3575c8 !important;\n    border-radius: 5px;\n}\n", ""]);

